import gql from "graphql-tag";

export const ADD_WORKSPACE_FIELD = gql`
  mutation {
    addWorkspaceField
  }
`;
